  <template>

    <div class="row justify-content-between align-items-center">

      <div class="margins col-lg-4">
        <div class="row">
          <div class="col-xs-1 icon-width pl-3">
            <i class="material-icons text-jeff-yellow">place</i>
          </div>

          <a href="https://www.google.com/maps/place/Jefferson+County+Courthouse,+301+Market+St,+Steubenville,+OH+43952/@40.3599501,-80.6160605,17z/data=!4m13!1m7!3m6!1s0x883431c6d216461f:0x8c5c7321f4d55f73!2sJefferson+County+Courthouse,+301+Market+St,+Steubenville,+OH+43952!3b1!8m2!3d40.3599501!4d-80.6138718!3m4!1s0x883431c6d216461f:0x8c5c7321f4d55f73!8m2!3d40.3599501!4d-80.6138718" target="blank">
            <div class="col-xs-11">  
              <div>
                Jefferson County
              </div>
              <div>
                301 Market Street
              </div>
              <div>
                Steubenville, OH 43952
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="margins col-lg-4 align-self-start">
        <!-- <i class="material-icons icon-padding">call</i> (740) 282-5555<br />
        <i class="material-icons icon-padding">email</i> <a class="link-hover" href="mailto:contact@jeffersoncountyoh.com">contact@jeffersoncountyoh.com</a><br /> -->
        <icon-text icon="group"><router-link class="link-hover" to="/county-directory">County Departments Directory</router-link></icon-text>
      </div>

      <div class="margins col-lg-auto">
        <icon-text icon="label"><router-link to="/terms-of-use">Terms Of Service</router-link></icon-text>
        <icon-text icon="label"><router-link to="/privacy-policy">Privacy Policy</router-link></icon-text>
        <icon-text icon="label"><router-link to="/employee-resources">Employee Resources</router-link></icon-text>
      </div>

    </div>

</template>

<script>

import IconText from '@/components/display-utils/IconText'

export default {
  components: {
    IconText
  },
  data () {
    return {}
  }
}
</script>

<style scoped>

.icon-padding {
  margin-right: 15px;
}

.icon-width {
  margin-right: 10px;
}

.margins {
  margin: 20px 0 20px 0px;
}

</style>
